import {
  Button,
  Card,
  NavBar,
  Toast,
  Field,
  PasswordInput,
  NumberKeyboard,
  Popup,
  Area,
  Dialog,
  Divider,
  Picker,
  Cell,
  CellGroup,
  Radio,
  RadioGroup,
  Icon,
  DropdownMenu,
  DropdownItem,
  List,
  PullRefresh,
  Search,
  Step,
  Steps,
  Tag,
  Tab,
  Tabs,
  Calendar,
  ActionSheet,
  Circle,
  Overlay,
  Switch,
  Uploader,
  Checkbox,
  CheckboxGroup,
  Cascader,
  Form,
  CountDown,
  Empty,
  ImagePreview,
  Swipe,
  SwipeItem,
  ConfigProvider,
  ActionBar,
  ActionBarButton,
  DatetimePicker
} from 'vant';

import 'vant/lib/index.css';

const components = [
  Button,
  Card,
  NavBar,
  Toast,
  Field,
  PasswordInput,
  NumberKeyboard,
  Popup,
  Area,
  Dialog,
  Divider,
  Picker,
  Cell,
  CellGroup,
  Radio,
  RadioGroup,
  Icon,
  DropdownMenu,
  DropdownItem,
  List,
  PullRefresh,
  Search,
  Step,
  Steps,
  Tag,
  Tab,
  Tabs,
  Calendar,
  ActionSheet,
  Circle,
  Overlay,
  Switch,
  Uploader,
  Checkbox,
  CheckboxGroup,
  Cascader,
  Form,
  CountDown,
  Empty,
  ImagePreview,
  Swipe,
  SwipeItem,
  ConfigProvider,
  ActionBar,
  ActionBarButton,
  DatetimePicker
];
export default components;
